// Runtime-toggleable dev/QA test flags. In-memory only — NOT persisted, so every flag
// resets to its default on app start. This is intentional for destructive switches (e.g.
// forcing billing failures): a switch that breaks a flow must never silently survive a
// restart. The flags are only settable from Settings -> Developer Tools (visible to test
// users / staging), so production builds can never turn them on.
export const devTestSettings = {
  // When true, BillingService.process{Apple,Google}Purchase throws AFTER the store payment
  // has completed, leaving the purchase owned-but-unacknowledged so the IAP reconciliation
  // path can be exercised. Turn it on, buy, then turn it off (or relaunch) to verify recovery.
  forceBillingFailure: false,
};
